// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a5544b2a] .v-text-field--outlined>.v-input__control>.v-input__slot{background-color:#fff}.bg-white[data-v-a5544b2a]{background-color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
